import { PolymorphicComponentProps } from "@omni/types/components/utils/polymorphic.types";
import { cn } from "@omni/utils/styles";
import React from "react";

type BadgeColorVariants = "default" | "inverse";

const BadgeColorVariants: Record<BadgeColorVariants, string> = {
    default: "tw:bg-primary tw:text-white",
    inverse: "tw:bg-background tw:text-primary"
};

export type BadgeComponentProps = {
    inverse?: boolean;
};

export type BadgeProps<T extends React.ElementType> = PolymorphicComponentProps<
    T,
    BadgeComponentProps,
    "span" | "a"
>;

const Badge = <T extends React.ElementType = "span">({
    className,
    inverse,
    tag,
    ...attributes
}: BadgeProps<T>) => {
    const Tag = tag || ("span" as React.ElementType);
    const classes = cn(
        "tw:inline-block tw:rounded-full tw:p-0 tw:text-xs tw:text-center tw:align-baseline tw:whitespace-nowrap tw:font-bold tw:leading-6 tw:w-6",
        BadgeColorVariants[inverse ? "inverse" : "default"],
        className
    );

    return (
        <Tag
            {...attributes}
            className={classes}
        />
    );
};

export { Badge };
